import { PCFooter } from '@commonPackage/components';
import { MetaConfig } from '@portalCommon/components';
import { RouterConfigEnum } from '@portalCommon/constants';
import { PointBurLEnumPortal, sendEventAndRedirectToConsultWitchParams } from '@portalCommon/utils';
import { IconPhone } from '@portalCommon/components/Icon';
import classnames from 'classnames/bind';
import { isHeadlessChrome } from '@yaotai/common-utils';
import { Back2Top, Contact, ContactBox, NavHeader, Consult } from '@/components';
import {
  SectionBlock,
  TranslateBanner,
  FadeRow,
  BringWhat,
  ClientChoose,
  AuthBlock,
  FirstScreen,
  ReferralBanner,
} from './components';
import { BANNER_DATA_LIST, FADE_ROW_DATA_LIST1, FADE_ROW_DATA_LIST2 } from './help';

import PersonalizedAvatar from './components/PersonalizedAvatar';
import Immersion from './components/Immersion';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export default function Home() {
  document.dispatchEvent(new Event('custom-render-trigger'));

  return (
    <>
      <MetaConfig routerPath={RouterConfigEnum.Home} />
      <div
        style={{
          display: isHeadlessChrome ? 'none' : 'block',
          position: 'relative',
        }}>
        <NavHeader isFixed isInitTransparent />
        <FirstScreen></FirstScreen>
        <SectionBlock
          wrapperStyle={{
            paddingTop: '66px',
            paddingBottom: '111px',
          }}
          titleStyle={{
            marginBottom: '60px',
          }}
          title="丰富虚拟场景任意选择">
          <TranslateBanner dataList={BANNER_DATA_LIST} />
          <div
            className={cx('contact-button')}
            onClick={() => {
              sendEventAndRedirectToConsultWitchParams(PointBurLEnumPortal.sceneSpaceConsult);
            }}>
            更多创意场景随心定制，请
            <span className={cx('contact-text')}>
              <IconPhone />
              联系我们
            </span>
          </div>
        </SectionBlock>

        <SectionBlock
          title="个性化虚拟形象"
          wrapperStyle={{
            height: '780px',
            paddingTop: '116px',
            backgroundImage:
              "url('https://static.fuxi.netease.com/yaotai/portal/index/lfc5y1sn_761879.jpg?image_process=format,webp')",
            backgroundSize: 'cover',
          }}>
          <PersonalizedAvatar />
        </SectionBlock>

        <SectionBlock
          title="沉浸式互动体验云端共享"
          wrapperStyle={{
            height: '754px',
            paddingTop: '106px',
          }}>
          <Immersion />
        </SectionBlock>

        <SectionBlock
          wrapperStyle={{
            height: '933px',
            paddingTop: '116px',
            backgroundImage:
              "url('https://static.fuxi.netease.com/yaotai/portal/index/lfq9kd4l_368308.png?image_process=format,webp')",
            backgroundSize: 'cover',
          }}
          title="一站式活动服务快捷稳定">
          <FadeRow
            style={{ marginBottom: '28px', marginTop: '55px' }}
            left={FADE_ROW_DATA_LIST1[0]}
            right={FADE_ROW_DATA_LIST1[1]}
          />
          <FadeRow left={FADE_ROW_DATA_LIST2[0]} right={FADE_ROW_DATA_LIST2[1]} />
        </SectionBlock>
        <section className={cx('block-bg')}>
          <SectionBlock title="网易瑶台能为您带来什么？" wrapperStyle={{ paddingTop: 60 }}>
            <BringWhat />
          </SectionBlock>
          <SectionBlock title="众多客户的信任和选择">
            <ClientChoose />
          </SectionBlock>
        </section>
        <Consult routerPath={RouterConfigEnum.Home} />
        <AuthBlock />

        <Contact />
        <PCFooter isMain={import.meta.env.VITE_MAIN === 'true'} isNeedImgLazyLoad={true} />
        <ContactBox />
        <Back2Top />
        {import.meta.env.VITE_MAIN === 'true' && <ReferralBanner />}
        <div id="captcha_activity"></div>
      </div>
    </>
  );
}
